import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import MobileNavbar from "../../components/MobileNavbar";

import POSPage from "./Pos";
import PageContainer from "../../components/PageContainer";

const ManagePOS = () => {
  const [range, setRange] = useState("7days");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [greeting, setGreeting] = useState("");
const user = JSON.parse(localStorage.getItem("user"));
const userName = user?.name || user?.firstName || "User";
	 return (
	<div className="h-screen flex flex-col">


			 {/* MOBILE NAVBAR */}
			 <MobileNavbar
				 title="POS"
				 onMenuClick={() => setSidebarOpen(true)}
			 />
			 {/* SIDEBAR */}
			 <Sidebar
				 isOpen={sidebarOpen}
				 onClose={() => setSidebarOpen(false)}
			 />
			 {/* HEADER */}
			 <Header onMenuClick={() => setSidebarOpen(true)} />
			 {/* MAIN CONTENT */}
			 <div className="flex-1 w-full h-full flex flex-col overflow-hidden">

				 <div className="pt-16 lg:pl-64 h-full w-full">
					 <POSPage />
				 </div>
			 </div>
		 </div>
	 );
};

export default ManagePOS;
